import React, { useContext, useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { UserContext } from "../../../Context/UserContext.js";
import { CompanyContext } from "../../../Context/CompanyContext.js";


   export default function ReportOrder({saveMethod}) {
      const {userToken } = useContext(UserContext) ;
      const {allCompanyInfo , getAllCompanyInfo } = useContext(CompanyContext) ;
      const [btnLoading , setBtnLoading] = useState(false) ;
      const closeBtnRef = useRef() ;


      const header = {
         token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
      }


      const handleSubmit = async(values, { resetForm }) => {
         setBtnLoading(true) ;
         values = {
            start: values.start || new Date(new Date().setUTCHours(0, 0, 0, 0)) , 
            end: values.end || undefined , 
            company: values.company || undefined , 
            patient: values.patient || undefined , 
         }
         await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/report?saveMethod=${saveMethod}` , values , {headers:header})
         .then(({data})=>{
            if(data.message === "success"){
               setBtnLoading(false) ;
               try {
                  // window.open(data.pathFile, '_blank');
                  window.open(data.pathFile, '_blank', 'noopener , noreferrer');
               } catch (error) {
                  toast.error(error) ;
               }
            }
         })
         .catch((error)=>{
            setBtnLoading(false) ;
            toast.warning(error.response.data.message)
         })
         resetForm();
         closeBtnRef.current.click() ;
      };


      const initialValues = {
         start: "",
         end: "",
         company: "",
         patient: "",
      } ;
      const validationSchema = Yup.object({
         start:Yup.string().trim() ,
         end:Yup.string().trim() ,
         company:Yup.string().trim() ,
         patient:Yup.string().trim()
      });


      useEffect(() => {
         getAllCompanyInfo();
      }, [])
      return (
            <div className="ReportOrder-container">
               <div className="modal fade" id="ReportOrder" tabIndex="-1" aria-labelledby="ReportOrderLabel" aria-hidden="true">
                  <div className="modal-dialog">
                     <div className="modal-content">

                        <div className="modal-header">
                           <h5 className="modal-title" id="ReportOrderLabel">تقارير الطلبات</h5>
                           <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                        </div>

                        <div className="modal-body">
                           <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize >
                              <Form>
                                 <div className="mb-3">
                                    <label className="form-label">تاريخ البداية </label>
                                    <Field type="date" name="start" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="start" /></div>
                                 </div>

                                 <div className="mb-3">
                                    <label className="form-label">تاريخ النهاية</label>
                                    <Field type="date" name="end" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="end" /></div>
                                 </div>


                                 <div className="mb-3">
                                    <label className="form-label">أختر الشركة المطلوب عمل لها تقارير الطلبات</label>
                                    <Field as="select" name="company" className="form-select">
                                       <option value="">اختر الشركة</option>
                                       {allCompanyInfo.length > 0 ? 
                                          allCompanyInfo.map((company)=><option value={company._id}>{company.name}</option>): ""}
                                    </Field>
                                    <div className="text-danger"><ErrorMessage name="company" /></div>
                                 </div>

                                 <div className="mb-3">
                                    <label className="form-label">اسم او تليفون المريض المراد عمل تقارير لة</label>
                                    <Field type="text" name="patient" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="patient" /></div>
                                 </div>

                                 <div className="d-flex justify-content-end">
                                    {btnLoading? 
                                          <button className="btn btn-danger"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i> Loading ...</button>
                                       : 
                                          <button type="submit" className="btn bg-main"><i className="fa-solid fa-print mx-2"></i> طباعة التقارير</button>
                                    }
                                 </div>
                              </Form>
                           </Formik>
                        </div>

                     </div>
                  </div>
               </div>
            </div>
         );
   }
